import { SET_CHECKOUT_HEADER_OPTIONS} from './types';


export const checkOutHeaderOptionsAction = (showDelivery)  => dispatch => {
    console.log('showDelivery in action ', showDelivery);
  dispatch({ 
        type: SET_CHECKOUT_HEADER_OPTIONS,
        showDelivery: showDelivery,
              
    })

}